import { useEffect, useState } from "react"
import { getAllAccesses, setRoleAccess } from "../Common/rolesAccessSlice"
import { useDispatch, useSelector } from "react-redux"
import RoleAccess from "../Common/roleAccess"
import { AppDispatch } from "../../store/Store"

const SITES_PERMISSIONS = {
    ADD_SITE: "Add Ticket",
    VIEW_SITE_TABLE: "View Tickets",
    EDIT_SITE: "Edit Ticket",
}

const useSitesAccess = () => {
    const [viewSitesTable, setViewSitesTable] = useState(true)
    const [addSitesPermission, setAddSitesPermission] = useState(false)
    const [editSitesPermission, setEditSitesPermission] = useState(false)
    const [addSitesProjectsPermission, setAddSitesProjectsPermission] = useState(false)
    const [addTagAccess, setAddTagAccess] = useState(false)
    const [viewTagAccess, setViewTagAccess] = useState(false)
    const [editTagAccess, setEditTagAccess] = useState(false)
    const [deleteTagIdAccess, setDeleteTagIdAccess] = useState(false)
    const [downloadSitesAccess, setDownloadSitesAccess] = useState(false)

    const allAccesses: any = useSelector(getAllAccesses)
    const {
        loginData: { user_data },
    } = useSelector((store: any) => store.verifyLogin)

    const dispatch = useDispatch<AppDispatch>()

    const allRoleAccess = RoleAccess()
    const rolesObjValues: any = Object.values(allRoleAccess)

    const getModulesArr = () => {
        const rolesData = rolesObjValues?.filter((rolesdetail: any) => rolesdetail.module_id === 15)
        return rolesData
    }

    useEffect(() => {
        //For superadmin only
        if (user_data?.role_id === 1 || user_data?.role_id === 51) {
            setEditSitesPermission(true)
        }
    }, [user_data])

    const handleAccessControl = () => {
        if (allAccesses?.data?.length) {
            allAccesses?.data?.forEach((permission: any) => {
                switch (permission?.title) {
                    case SITES_PERMISSIONS.ADD_SITE:
                        setAddSitesPermission(permission?.value)
                        break
                    case SITES_PERMISSIONS.VIEW_SITE_TABLE:
                        setViewSitesTable(permission?.value)
                        break
                    case SITES_PERMISSIONS.EDIT_SITE:
                        setEditSitesPermission(permission?.value)
                        break
                    case 'Download Tickets':
                        setDownloadSitesAccess(permission?.value)
                        break;
                    case "Add Tag":
                        setAddTagAccess(permission?.value)
                        break;
                    case "Map Tag":
                        setEditTagAccess(permission?.value)
                        break;
                    case "View Tag":
                        setViewTagAccess(permission?.value)
                        break;
                    case "Unmap Tag":
                        setDeleteTagIdAccess(permission?.value)
                        break;
                }
            })
        } else {
            setAddSitesPermission(false)
            setViewSitesTable(false)
            setAddSitesProjectsPermission(false)
        }
    }
    useEffect(() => {
        const modulesArr: any = getModulesArr()
        dispatch(setRoleAccess(modulesArr))
        handleAccessControl()
    }, [allAccesses?.data])

    return {
        viewSitesTable,
        addSitesPermission,
        editSitesPermission,
        addSitesProjectsPermission,
        viewTagAccess,
        addTagAccess,
        editTagAccess,
        deleteTagIdAccess,
        downloadSitesAccess
    }
}

export default useSitesAccess
